:host {
  display: block;
}

klevu-typography.caption {
  display: block;
  margin-bottom: var(--klevu-spacing-02);
}

klevu-list:hover {
  cursor: pointer;
  background: var(--klevu-color-neutral-2);
}
